import { Map as ImmutableMap } from 'immutable';
import { StringDisplayType } from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import I18n from 'I18n';
export default (({
  filterFamily,
  displayType = StringDisplayType
}) => DSFieldRecord({
  displayType,
  label: I18n.text(`customerDataFiltersUI.customerDataFilters.DSAssetFamilyNames.${filterFamily}`),
  metadata: ImmutableMap({
    hasNoFieldOptions: true
  }),
  name: filterFamily,
  type: filterFamily
}));